export interface DialEntry {
  cc: string;
  code: string;
  flag: string;
  label: string;
}

// Sorted roughly by popularity for our audience (IL/UA/DE/GB/RU/US first).
// All countries validate phone length as 4–15 digits (E.164 bounds).
export const DIAL_CODES: readonly DialEntry[] = [
  { cc: 'IL', code: '+972', flag: '🇮🇱', label: 'Israel' },
  { cc: 'UA', code: '+380', flag: '🇺🇦', label: 'Ukraine' },
  { cc: 'DE', code: '+49', flag: '🇩🇪', label: 'Germany' },
  { cc: 'GB', code: '+44', flag: '🇬🇧', label: 'United Kingdom' },
  { cc: 'RU', code: '+7', flag: '🇷🇺', label: 'Russia' },
  { cc: 'US', code: '+1', flag: '🇺🇸', label: 'United States' },
  { cc: 'FR', code: '+33', flag: '🇫🇷', label: 'France' },
  { cc: 'ES', code: '+34', flag: '🇪🇸', label: 'Spain' },
  { cc: 'IT', code: '+39', flag: '🇮🇹', label: 'Italy' },
  { cc: 'BY', code: '+375', flag: '🇧🇾', label: 'Belarus' },
  { cc: 'KZ', code: '+7', flag: '🇰🇿', label: 'Kazakhstan' },
  { cc: 'AM', code: '+374', flag: '🇦🇲', label: 'Armenia' },
  { cc: 'AZ', code: '+994', flag: '🇦🇿', label: 'Azerbaijan' },
  { cc: 'GE', code: '+995', flag: '🇬🇪', label: 'Georgia' },
  { cc: 'KG', code: '+996', flag: '🇰🇬', label: 'Kyrgyzstan' },
  { cc: 'MD', code: '+373', flag: '🇲🇩', label: 'Moldova' },
  { cc: 'TJ', code: '+992', flag: '🇹🇯', label: 'Tajikistan' },
  { cc: 'TM', code: '+993', flag: '🇹🇲', label: 'Turkmenistan' },
  { cc: 'UZ', code: '+998', flag: '🇺🇿', label: 'Uzbekistan' },
  { cc: 'CA', code: '+1', flag: '🇨🇦', label: 'Canada' },
  { cc: 'AU', code: '+61', flag: '🇦🇺', label: 'Australia' },
  { cc: 'NZ', code: '+64', flag: '🇳🇿', label: 'New Zealand' },
  { cc: 'AT', code: '+43', flag: '🇦🇹', label: 'Austria' },
  { cc: 'BE', code: '+32', flag: '🇧🇪', label: 'Belgium' },
  { cc: 'BG', code: '+359', flag: '🇧🇬', label: 'Bulgaria' },
  { cc: 'HR', code: '+385', flag: '🇭🇷', label: 'Croatia' },
  { cc: 'CY', code: '+357', flag: '🇨🇾', label: 'Cyprus' },
  { cc: 'CZ', code: '+420', flag: '🇨🇿', label: 'Czech Republic' },
  { cc: 'DK', code: '+45', flag: '🇩🇰', label: 'Denmark' },
  { cc: 'EE', code: '+372', flag: '🇪🇪', label: 'Estonia' },
  { cc: 'FI', code: '+358', flag: '🇫🇮', label: 'Finland' },
  { cc: 'GR', code: '+30', flag: '🇬🇷', label: 'Greece' },
  { cc: 'HU', code: '+36', flag: '🇭🇺', label: 'Hungary' },
  { cc: 'IS', code: '+354', flag: '🇮🇸', label: 'Iceland' },
  { cc: 'IE', code: '+353', flag: '🇮🇪', label: 'Ireland' },
  { cc: 'LV', code: '+371', flag: '🇱🇻', label: 'Latvia' },
  { cc: 'LT', code: '+370', flag: '🇱🇹', label: 'Lithuania' },
  { cc: 'LU', code: '+352', flag: '🇱🇺', label: 'Luxembourg' },
  { cc: 'MT', code: '+356', flag: '🇲🇹', label: 'Malta' },
  { cc: 'NL', code: '+31', flag: '🇳🇱', label: 'Netherlands' },
  { cc: 'NO', code: '+47', flag: '🇳🇴', label: 'Norway' },
  { cc: 'PL', code: '+48', flag: '🇵🇱', label: 'Poland' },
  { cc: 'PT', code: '+351', flag: '🇵🇹', label: 'Portugal' },
  { cc: 'RO', code: '+40', flag: '🇷🇴', label: 'Romania' },
  { cc: 'RS', code: '+381', flag: '🇷🇸', label: 'Serbia' },
  { cc: 'SK', code: '+421', flag: '🇸🇰', label: 'Slovakia' },
  { cc: 'SI', code: '+386', flag: '🇸🇮', label: 'Slovenia' },
  { cc: 'SE', code: '+46', flag: '🇸🇪', label: 'Sweden' },
  { cc: 'CH', code: '+41', flag: '🇨🇭', label: 'Switzerland' },
  { cc: 'TR', code: '+90', flag: '🇹🇷', label: 'Turkey' },
  { cc: 'AL', code: '+355', flag: '🇦🇱', label: 'Albania' },
  { cc: 'BA', code: '+387', flag: '🇧🇦', label: 'Bosnia & Herzegovina' },
  { cc: 'MK', code: '+389', flag: '🇲🇰', label: 'North Macedonia' },
  { cc: 'ME', code: '+382', flag: '🇲🇪', label: 'Montenegro' },
  { cc: 'AR', code: '+54', flag: '🇦🇷', label: 'Argentina' },
  { cc: 'BR', code: '+55', flag: '🇧🇷', label: 'Brazil' },
  { cc: 'CL', code: '+56', flag: '🇨🇱', label: 'Chile' },
  { cc: 'CO', code: '+57', flag: '🇨🇴', label: 'Colombia' },
  { cc: 'MX', code: '+52', flag: '🇲🇽', label: 'Mexico' },
  { cc: 'PE', code: '+51', flag: '🇵🇪', label: 'Peru' },
  { cc: 'VE', code: '+58', flag: '🇻🇪', label: 'Venezuela' },
  { cc: 'UY', code: '+598', flag: '🇺🇾', label: 'Uruguay' },
  { cc: 'BO', code: '+591', flag: '🇧🇴', label: 'Bolivia' },
  { cc: 'EC', code: '+593', flag: '🇪🇨', label: 'Ecuador' },
  { cc: 'PY', code: '+595', flag: '🇵🇾', label: 'Paraguay' },
  { cc: 'CR', code: '+506', flag: '🇨🇷', label: 'Costa Rica' },
  { cc: 'PA', code: '+507', flag: '🇵🇦', label: 'Panama' },
  { cc: 'DO', code: '+1', flag: '🇩🇴', label: 'Dominican Republic' },
  { cc: 'JM', code: '+1', flag: '🇯🇲', label: 'Jamaica' },
  { cc: 'CU', code: '+53', flag: '🇨🇺', label: 'Cuba' },
  { cc: 'HT', code: '+509', flag: '🇭🇹', label: 'Haiti' },
  { cc: 'GT', code: '+502', flag: '🇬🇹', label: 'Guatemala' },
  { cc: 'HN', code: '+504', flag: '🇭🇳', label: 'Honduras' },
  { cc: 'NI', code: '+505', flag: '🇳🇮', label: 'Nicaragua' },
  { cc: 'SV', code: '+503', flag: '🇸🇻', label: 'El Salvador' },
  { cc: 'CN', code: '+86', flag: '🇨🇳', label: 'China' },
  { cc: 'HK', code: '+852', flag: '🇭🇰', label: 'Hong Kong' },
  { cc: 'TW', code: '+886', flag: '🇹🇼', label: 'Taiwan' },
  { cc: 'JP', code: '+81', flag: '🇯🇵', label: 'Japan' },
  { cc: 'KR', code: '+82', flag: '🇰🇷', label: 'South Korea' },
  { cc: 'IN', code: '+91', flag: '🇮🇳', label: 'India' },
  { cc: 'PK', code: '+92', flag: '🇵🇰', label: 'Pakistan' },
  { cc: 'BD', code: '+880', flag: '🇧🇩', label: 'Bangladesh' },
  { cc: 'LK', code: '+94', flag: '🇱🇰', label: 'Sri Lanka' },
  { cc: 'NP', code: '+977', flag: '🇳🇵', label: 'Nepal' },
  { cc: 'MM', code: '+95', flag: '🇲🇲', label: 'Myanmar' },
  { cc: 'MV', code: '+960', flag: '🇲🇻', label: 'Maldives' },
  { cc: 'ID', code: '+62', flag: '🇮🇩', label: 'Indonesia' },
  { cc: 'MY', code: '+60', flag: '🇲🇾', label: 'Malaysia' },
  { cc: 'PH', code: '+63', flag: '🇵🇭', label: 'Philippines' },
  { cc: 'SG', code: '+65', flag: '🇸🇬', label: 'Singapore' },
  { cc: 'TH', code: '+66', flag: '🇹🇭', label: 'Thailand' },
  { cc: 'VN', code: '+84', flag: '🇻🇳', label: 'Vietnam' },
  { cc: 'KH', code: '+855', flag: '🇰🇭', label: 'Cambodia' },
  { cc: 'LA', code: '+856', flag: '🇱🇦', label: 'Laos' },
  { cc: 'MN', code: '+976', flag: '🇲🇳', label: 'Mongolia' },
  { cc: 'AE', code: '+971', flag: '🇦🇪', label: 'United Arab Emirates' },
  { cc: 'SA', code: '+966', flag: '🇸🇦', label: 'Saudi Arabia' },
  { cc: 'QA', code: '+974', flag: '🇶🇦', label: 'Qatar' },
  { cc: 'KW', code: '+965', flag: '🇰🇼', label: 'Kuwait' },
  { cc: 'BH', code: '+973', flag: '🇧🇭', label: 'Bahrain' },
  { cc: 'OM', code: '+968', flag: '🇴🇲', label: 'Oman' },
  { cc: 'JO', code: '+962', flag: '🇯🇴', label: 'Jordan' },
  { cc: 'LB', code: '+961', flag: '🇱🇧', label: 'Lebanon' },
  { cc: 'SY', code: '+963', flag: '🇸🇾', label: 'Syria' },
  { cc: 'IQ', code: '+964', flag: '🇮🇶', label: 'Iraq' },
  { cc: 'IR', code: '+98', flag: '🇮🇷', label: 'Iran' },
  { cc: 'AF', code: '+93', flag: '🇦🇫', label: 'Afghanistan' },
  { cc: 'YE', code: '+967', flag: '🇾🇪', label: 'Yemen' },
  { cc: 'PS', code: '+970', flag: '🇵🇸', label: 'Palestine' },
  { cc: 'EG', code: '+20', flag: '🇪🇬', label: 'Egypt' },
  { cc: 'ZA', code: '+27', flag: '🇿🇦', label: 'South Africa' },
  { cc: 'NG', code: '+234', flag: '🇳🇬', label: 'Nigeria' },
  { cc: 'KE', code: '+254', flag: '🇰🇪', label: 'Kenya' },
  { cc: 'ET', code: '+251', flag: '🇪🇹', label: 'Ethiopia' },
  { cc: 'GH', code: '+233', flag: '🇬🇭', label: 'Ghana' },
  { cc: 'MA', code: '+212', flag: '🇲🇦', label: 'Morocco' },
  { cc: 'DZ', code: '+213', flag: '🇩🇿', label: 'Algeria' },
  { cc: 'TN', code: '+216', flag: '🇹🇳', label: 'Tunisia' },
  { cc: 'LY', code: '+218', flag: '🇱🇾', label: 'Libya' },
  { cc: 'SD', code: '+249', flag: '🇸🇩', label: 'Sudan' },
  { cc: 'TZ', code: '+255', flag: '🇹🇿', label: 'Tanzania' },
  { cc: 'UG', code: '+256', flag: '🇺🇬', label: 'Uganda' },
  { cc: 'ZW', code: '+263', flag: '🇿🇼', label: 'Zimbabwe' },
  { cc: 'ZM', code: '+260', flag: '🇿🇲', label: 'Zambia' },
  { cc: 'MW', code: '+265', flag: '🇲🇼', label: 'Malawi' },
  { cc: 'MZ', code: '+258', flag: '🇲🇿', label: 'Mozambique' },
  { cc: 'BW', code: '+267', flag: '🇧🇼', label: 'Botswana' },
  { cc: 'NA', code: '+264', flag: '🇳🇦', label: 'Namibia' },
  { cc: 'CM', code: '+237', flag: '🇨🇲', label: 'Cameroon' },
  { cc: 'CI', code: '+225', flag: '🇨🇮', label: 'Côte d’Ivoire' },
  { cc: 'SN', code: '+221', flag: '🇸🇳', label: 'Senegal' },
  { cc: 'ML', code: '+223', flag: '🇲🇱', label: 'Mali' },
  { cc: 'BF', code: '+226', flag: '🇧🇫', label: 'Burkina Faso' },
  { cc: 'NE', code: '+227', flag: '🇳🇪', label: 'Niger' },
  { cc: 'TD', code: '+235', flag: '🇹🇩', label: 'Chad' },
  { cc: 'CF', code: '+236', flag: '🇨🇫', label: 'Central African Republic' },
  { cc: 'CG', code: '+242', flag: '🇨🇬', label: 'Republic of the Congo' },
  { cc: 'CD', code: '+243', flag: '🇨🇩', label: 'DR Congo' },
  { cc: 'GA', code: '+241', flag: '🇬🇦', label: 'Gabon' },
  { cc: 'GN', code: '+224', flag: '🇬🇳', label: 'Guinea' },
  { cc: 'GQ', code: '+240', flag: '🇬🇶', label: 'Equatorial Guinea' },
  { cc: 'GW', code: '+245', flag: '🇬🇼', label: 'Guinea-Bissau' },
  { cc: 'LR', code: '+231', flag: '🇱🇷', label: 'Liberia' },
  { cc: 'SL', code: '+232', flag: '🇸🇱', label: 'Sierra Leone' },
  { cc: 'TG', code: '+228', flag: '🇹🇬', label: 'Togo' },
  { cc: 'BJ', code: '+229', flag: '🇧🇯', label: 'Benin' },
  { cc: 'MU', code: '+230', flag: '🇲🇺', label: 'Mauritius' },
  { cc: 'MG', code: '+261', flag: '🇲🇬', label: 'Madagascar' },
  { cc: 'RW', code: '+250', flag: '🇷🇼', label: 'Rwanda' },
  { cc: 'SO', code: '+252', flag: '🇸🇴', label: 'Somalia' },
  { cc: 'DJ', code: '+253', flag: '🇩🇯', label: 'Djibouti' },
  { cc: 'SC', code: '+248', flag: '🇸🇨', label: 'Seychelles' },
  { cc: 'KM', code: '+269', flag: '🇰🇲', label: 'Comoros' },
  { cc: 'ER', code: '+291', flag: '🇪🇷', label: 'Eritrea' },
  { cc: 'SS', code: '+211', flag: '🇸🇸', label: 'South Sudan' },
  { cc: 'CV', code: '+238', flag: '🇨🇻', label: 'Cape Verde' },
  { cc: 'ST', code: '+239', flag: '🇸🇹', label: 'São Tomé & Príncipe' },
  { cc: 'AO', code: '+244', flag: '🇦🇴', label: 'Angola' },
  { cc: 'LS', code: '+266', flag: '🇱🇸', label: 'Lesotho' },
  { cc: 'SZ', code: '+268', flag: '🇸🇿', label: 'Eswatini' },
  { cc: 'MR', code: '+222', flag: '🇲🇷', label: 'Mauritania' },
  { cc: 'GM', code: '+220', flag: '🇬🇲', label: 'Gambia' },
  { cc: 'BI', code: '+257', flag: '🇧🇮', label: 'Burundi' },
  { cc: 'MX', code: '+52', flag: '🇲🇽', label: 'Mexico' },
  { cc: 'AF', code: '+93', flag: '🇦🇫', label: 'Afghanistan' },
  { cc: 'AG', code: '+1', flag: '🇦🇬', label: 'Antigua & Barbuda' },
  { cc: 'BB', code: '+1', flag: '🇧🇧', label: 'Barbados' },
  { cc: 'BS', code: '+1', flag: '🇧🇸', label: 'Bahamas' },
  { cc: 'BZ', code: '+501', flag: '🇧🇿', label: 'Belize' },
  { cc: 'DM', code: '+1', flag: '🇩🇲', label: 'Dominica' },
  { cc: 'GD', code: '+1', flag: '🇬🇩', label: 'Grenada' },
  { cc: 'GY', code: '+592', flag: '🇬🇾', label: 'Guyana' },
  { cc: 'KN', code: '+1', flag: '🇰🇳', label: 'Saint Kitts & Nevis' },
  { cc: 'LC', code: '+1', flag: '🇱🇨', label: 'Saint Lucia' },
  { cc: 'SR', code: '+597', flag: '🇸🇷', label: 'Suriname' },
  { cc: 'TT', code: '+1', flag: '🇹🇹', label: 'Trinidad & Tobago' },
  { cc: 'VC', code: '+1', flag: '🇻🇨', label: 'Saint Vincent' },
  { cc: 'FJ', code: '+679', flag: '🇫🇯', label: 'Fiji' },
  { cc: 'PG', code: '+675', flag: '🇵🇬', label: 'Papua New Guinea' },
  { cc: 'SB', code: '+677', flag: '🇸🇧', label: 'Solomon Islands' },
  { cc: 'VU', code: '+678', flag: '🇻🇺', label: 'Vanuatu' },
  { cc: 'WS', code: '+685', flag: '🇼🇸', label: 'Samoa' },
  { cc: 'TO', code: '+676', flag: '🇹🇴', label: 'Tonga' },
  { cc: 'KI', code: '+686', flag: '🇰🇮', label: 'Kiribati' },
  { cc: 'FM', code: '+691', flag: '🇫🇲', label: 'Micronesia' },
  { cc: 'MH', code: '+692', flag: '🇲🇭', label: 'Marshall Islands' },
  { cc: 'PW', code: '+680', flag: '🇵🇼', label: 'Palau' },
  { cc: 'TV', code: '+688', flag: '🇹🇻', label: 'Tuvalu' },
  { cc: 'NR', code: '+674', flag: '🇳🇷', label: 'Nauru' },
  { cc: 'CK', code: '+682', flag: '🇨🇰', label: 'Cook Islands' },
  { cc: 'NU', code: '+683', flag: '🇳🇺', label: 'Niue' },
  { cc: 'PF', code: '+689', flag: '🇵🇫', label: 'French Polynesia' },
  { cc: 'NC', code: '+687', flag: '🇳🇨', label: 'New Caledonia' },
  { cc: 'WF', code: '+681', flag: '🇼🇫', label: 'Wallis & Futuna' },
  { cc: 'LI', code: '+423', flag: '🇱🇮', label: 'Liechtenstein' },
  { cc: 'MC', code: '+377', flag: '🇲🇨', label: 'Monaco' },
  { cc: 'SM', code: '+378', flag: '🇸🇲', label: 'San Marino' },
  { cc: 'VA', code: '+379', flag: '🇻🇦', label: 'Vatican City' },
  { cc: 'AD', code: '+376', flag: '🇦🇩', label: 'Andorra' },
  { cc: 'XK', code: '+383', flag: '🇽🇰', label: 'Kosovo' },
  { cc: 'FO', code: '+298', flag: '🇫🇴', label: 'Faroe Islands' },
  { cc: 'GL', code: '+299', flag: '🇬🇱', label: 'Greenland' },
  { cc: 'GI', code: '+350', flag: '🇬🇮', label: 'Gibraltar' },
  { cc: 'IM', code: '+44', flag: '🇮🇲', label: 'Isle of Man' },
  { cc: 'JE', code: '+44', flag: '🇯🇪', label: 'Jersey' },
  { cc: 'GG', code: '+44', flag: '🇬🇬', label: 'Guernsey' },
  { cc: 'BM', code: '+1', flag: '🇧🇲', label: 'Bermuda' },
  { cc: 'KY', code: '+1', flag: '🇰🇾', label: 'Cayman Islands' },
  { cc: 'AI', code: '+1', flag: '🇦🇮', label: 'Anguilla' },
  { cc: 'MS', code: '+1', flag: '🇲🇸', label: 'Montserrat' },
  { cc: 'VG', code: '+1', flag: '🇻🇬', label: 'British Virgin Islands' },
  { cc: 'TC', code: '+1', flag: '🇹🇨', label: 'Turks & Caicos' },
  { cc: 'PR', code: '+1', flag: '🇵🇷', label: 'Puerto Rico' },
  { cc: 'GU', code: '+1', flag: '🇬🇺', label: 'Guam' },
  { cc: 'AS', code: '+1', flag: '🇦🇸', label: 'American Samoa' },
  { cc: 'MP', code: '+1', flag: '🇲🇵', label: 'Northern Mariana Is.' },
  { cc: 'VI', code: '+1', flag: '🇻🇮', label: 'U.S. Virgin Islands' },
].filter((v, i, a) => a.findIndex((x) => x.cc === v.cc) === i);
